import type { AppConfig } from '~/types/app-config'

export const useAppConfigStore = defineStore('appConfig', () => {
  const appConfig = ref<AppConfig | null>(null)
  const isNotExistConfigFile = ref(false)

  const loadAppConfig = async () => {
    //console.log(' >> loadAppConfig')
    if (!appConfig.value && !isNotExistConfigFile.value) {
      try {
        const result = await $fetch('/config/app-config.json', {
          responseType: 'json',
          cache: 'no-store'
        })
        if (typeof result === 'object' && result !== null) {
          appConfig.value = result as AppConfig
        } else {
          //console.warn('Invalid config format. Expected JSON, got:', result)
          appConfig.value = null
          isNotExistConfigFile.value = true
        }
      } catch (error) {
        //console.error('Error loading config:', error)
        appConfig.value = null
        isNotExistConfigFile.value = true
      }
    }
    //return appConfig.value
  }

  return {
    loadAppConfig,
    appConfig
  }
})
